module.exports = global["$"] = require("-!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?$!./~/jquery/dist/jquery.js
// module id = 473
// module chunks = 2